
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { TableCell, TableRow } from "@/components/ui/table";
import { Edit, Trash2, Pause, Play } from "lucide-react";
import { Product } from "@/types/product";

interface ProductTableRowProps {
  product: Product;
  onEdit: (product: Product) => void;
  onDelete: (product: Product) => void;
  onToggleStatus: (product: Product) => void;
}

const ProductTableRow = ({ product, onEdit, onDelete, onToggleStatus }: ProductTableRowProps) => {
  return (
    <TableRow>
      <TableCell>
        <div className="w-16 h-16">
          <img
            src={product.image_url || "/placeholder.svg"}
            alt={product.name}
            className="w-full h-full object-cover rounded"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = "/placeholder.svg";
            }}
          />
        </div>
      </TableCell>
      <TableCell>
        <div>
          <p className="font-medium text-foreground">{product.name}</p>
          <p className="text-sm text-muted-foreground truncate max-w-xs">
            {product.description}
          </p>
        </div>
      </TableCell>
      <TableCell>
        <span className="px-2 py-1 bg-muted rounded text-sm text-muted-foreground border border-border">
          {product.category}
        </span>
      </TableCell>
      <TableCell className="font-bold text-foreground">
        R$ {product.price.toFixed(2)}
      </TableCell>
      <TableCell>
        <Badge variant={product.is_active ? "default" : "destructive"}>
          {product.is_active ? "Ativo" : "Pausado"}
        </Badge>
      </TableCell>
      <TableCell>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onEdit(product)}
            className="border-border hover:bg-accent text-foreground"
          >
            <Edit className="h-4 w-4" />
            <span className="ml-1">Editar</span>
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onToggleStatus(product)}
            className={product.is_active 
              ? "border-orange-600/70 hover:bg-orange-500/10 text-orange-600 dark:text-orange-400 dark:border-orange-700 dark:hover:bg-orange-900"
              : "border-green-600/70 hover:bg-green-500/10 text-green-600 dark:text-green-400 dark:border-green-700 dark:hover:bg-green-900"
            }
          >
            {product.is_active ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}
            <span className="ml-1">{product.is_active ? "Pausar" : "Reativar"}</span>
          </Button>
          <Button
            variant="outline" 
            size="sm"
            onClick={() => onDelete(product)}
            className="border-red-600/70 hover:bg-red-500/10 text-red-600 dark:text-red-400 dark:border-red-700 dark:hover:bg-red-900"
          >
            <Trash2 className="h-4 w-4" />
            <span className="ml-1">Excluir</span>
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default ProductTableRow;
